import * as yup from "yup";
import { BookingErrorsDto } from "../../../../Api/Model/BookingSteps/BookingErrorsDto.csharp";
import { FormFields } from "../Helpers/formTypes";

export const firstStepValidator = (errors: BookingErrorsDto) =>
  yup.object().shape({
    specialization: yup
      .mixed()
      .test("required", errors.specializationSelection, hasIdFilled),
    service: yup.mixed().when(FormFields.specialization, {
      is: hasIdFilled,
      then: yup.mixed().test("required", errors.serviceSelection, (service, context) => hasIdFilled(service) || hasIdFilled(context.parent.serviceGroup)),
    }),
    serviceSecondLevel: yup.mixed().when(FormFields.serviceGroup, {
        is: hasIdFilled,
        then: yup.mixed().test("required", errors.serviceSelection, (_, context) => hasIdFilled(context.parent.service)),
    }),
    location: yup.mixed(),
  });

const hasIdFilled = (value: any) => value.hasOwnProperty("id") && value["id"];
